/* eslint-disable no-unused-vars */
import React, {Component} from 'react';
import {render} from 'react-dom';
import MapGL, { FlyToInterpolator } from 'react-map-gl';
import {json as requestJson} from 'd3-request';
import * as d3 from 'd3-ease'
import {fromJS} from 'immutable';
import _ from 'lodash';
import WebMercatorViewport from 'viewport-mercator-project';
import {
  firebaseConnect,
  isLoaded,
  isEmpty
} from 'react-redux-firebase';
import { Loader } from 'semantic-ui-react';
import ControlPanel from './control-panel';
import { getLineFeatures } from './utils';
import {defaultMapStyle, linesLayer, sessionLayer, lineLayer } from './map-style.js';
import { MAPBOX_TOKEN } from '../../../config/tokens';
import { createDataSource } from '../../../utils/map';

export default class App extends Component {

  state = {
    mapStyle: '',
    loading: true,
    viewport: {
      latitude: 39.1098747253418,
      longitude: -84.50493621826172,
      zoom: 1,
      bearing: 0,
      pitch: 0,
      width: 500,
      height: 500,
      maxZoom: 17,
      minZoom: 1,
    },
    drawSettings: {
      xFactor: 0.002,
      yFactor: 0.008,
      xOffset: -1.7,
      yOffset: -7.7,
      flipV: false,
      flipH: false,
      minzoom: 1,
      maxzoom: 11,
      widthFactor: 1,
    },
    features: [],
    addedToMap: false,
  }

  componentDidMount() {
    window.addEventListener('resize', this._resize);
    this._resize();
    if(this.state.loading && isLoaded(this.props.geoFire))
      this._loadData(this.props.geoFire);
  }

  componentDidUpdate(prevProps) {
    if(this.state.loading && isLoaded(this.props.geoFire))
      this._loadData(this.props.geoFire);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._resize);
  }

  _resize = () => {
    this.setState({
      viewport: {
        ...this.state.viewport,
        width: this.props.width || window.innerWidth,
        height: this.props.height || window.innerHeight
      }
    });
  };

  // LOAD DATA

  _loadData = geoFire => {
    // console.log('geoFire',geoFire)
    const session = _.find(geoFire)

    var linesData = createDataSource(this.props.features)
    // console.log(linesData)
    // set session point
    var sessionFeatureData = {
      "type": "FeatureCollection",
      "features": [{
        "type": "Feature",
        "geometry": {
          "type": "Point",
          "coordinates": [session.l[1],session.l[0]]
        },
        "properties" : {
            "id": this.props.sessionKey,
          }
    }]
  }


    // add lines to map
    var mapStyle = defaultMapStyle
      .setIn(['sources', 'session'], fromJS({type: 'geojson',data: fromJS(sessionFeatureData)}))
      .setIn(['sources', 'lines'], fromJS(linesData))
      .set('layers', defaultMapStyle.get('layers').push(sessionLayer))


    mapStyle = mapStyle
        .set('layers', mapStyle.get('layers').push(linesLayer))

    // data is good to go, create map
    this.setState({session, mapStyle});

    // Initialize Map
    this._initializeMap(session);
  };

  _initializeMap = (session) => {


    this._onViewportChange({
      width: this.props.width || window.innerWidth,
      height: this.props.height || window.innerHeight,
      longitude: session.l[1],
      latitude: session.l[0],
      zoom: 6,
    });

    this.setState({loading: false})

  }


  _drawLine = () => {
    // Create line geojson
    var features = getLineFeatures(this.state.session,this.state.drawSettings);
    var lines = {
      "type": "FeatureCollection",
      "features": features,
    };

    // console.log('lines',lines)

    // add lines to map
    var mapStyle = this.state.mapStyle
      .setIn(['sources', 'line'], fromJS({type: 'geojson',data: lines}))
      .set('layers', this.state.mapStyle.get('layers').push(lineLayer))


    this.setState({mapStyle, features})
  }


  _addToMap = () => {
    const keyedFeatureList = _.keyBy(this.state.features, 'properties.id');
    this.props.firebase.database().ref(`geojson/map_v1/features/`)
      .update(keyedFeatureList)
      .then(()=>{
        this.setState({addedToMap: true})
      })
  }

  _deleteFromMap = () => {
    const keyedFeatureList = _.keyBy(this.state.features, 'properties.id');
    _.forEach(keyedFeatureList, (line,key) => {
      console.log('d')

      this.props.firebase.database().ref(`geojson/map_v1/features/${key}`)
        .remove()
        .then(()=>{
          console.log('removed')
          this.setState({addedToMap: false })
        })
    })

  }


  _onViewportChange = viewport => {
    this.setState({
      viewport: {...this.state.viewport, ...viewport},
    });
  }

  _onDrawSettingsChange = drawSettings => {
    this.setState({
      drawSettings: {...this.state.drawSettings, ...drawSettings},
    });
  }

  _onMapLoad = event => {
    this.map = this.mapRef.getMap()
    // this._onMapMove();
    // event.target.on('move', this._onMapMove );

    // this._drawLine()
  }


  render() {
    if(!this.props.isAdmin) { return null; }
    const {viewport, mapStyle, loading} = this.state;

    if(loading)
      return <Loader active />


    return (
      <div>
      <MapGL
        ref={(el) => this.mapRef = el}
        {...viewport}
        mapStyle={mapStyle}
        onViewportChange={this._onViewportChange}
        mapboxApiAccessToken={MAPBOX_TOKEN}
        onLoad={this._onMapLoad}
        >
      </MapGL>



      <ControlPanel {...this.state} deleteFromMap={this._deleteFromMap} addToMap={this._addToMap} drawLine={this._drawLine} updateDrawSettings={this._onDrawSettingsChange} />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/Edit/Map.js